export const PolicyLayout = ({ title, icon, sub, children }) => (
  <div>
    <section className="bg-gradient-to-br from-[#111] to-gray-800 text-white py-20 px-4 text-center">
      <div className="text-5xl mb-4">{icon}</div>
      <h1 className="font-serif text-5xl mb-3">{title}</h1>
      <p className="text-gray-400">{sub}</p>
    </section>
    <div className="max-w-4xl mx-auto px-4 py-14">
      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-8">{children}</div>
    </div>
  </div>
);